import React from "react";
import { CGE } from "../CGE";

const CgeStyleGuide = () => {
    const [inputValue1, setInputValue1] = React.useState('')
    const [inputValue2, setInputValue2] = React.useState('')
    const [inputValue3, setInputValue3] = React.useState('TESTE')
    const [inputValue4, setInputValue4] = React.useState('')
    const [inputValue5, setInputValue5] = React.useState('')
    const [inputValue6, setInputValue6] = React.useState('')

    const listOptions = [
        { value: '', label: 'selecione option' },
        { value: 1, label: 'teste' },
        { value: 2, label: 'teste2' },
        { value: 3, label: 'teste3' },
    ]
    function handleChangeNumberCliente1(e) {
        setInputValue1(e.target.value)
    }

    function handleChangeNumberCliente2(e) {
        setInputValue2(e.target.value)
    }

    function handleChangeNumberCliente3(e) {
        setInputValue3(e.target.value)
    }

    function handleChangeNumberCliente4(e) {
        setInputValue4(e.target.value)
    }

    function handleChangeNumberCliente5(e) {
        setInputValue5(e.target.value)
    }

    function handleChangeNumberCliente6(e) {
        setInputValue6(e.target.value)
    }

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <CGE.Title title="Style Guide" description="Button, Texts, Heading, Spacing, Icons, Form, Card, Colors, Panel" />
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <CGE.Title title="Button" description="" />
                </div>
            </div>
            <div className="row">
                <div className="col-md-2">
                    <CGE.Title title="" description="Primary" />
                    <CGE.Button type="primary" label="Button" onClick={() => { alert("Primary") }} />
                </div>
                <div className="col-md-2">
                    <CGE.Title title="" description="Primary Disabled" />
                    <CGE.Button type="primary" disabled={true} label="Button" />
                </div>
                <div className="col-md-2">
                    <CGE.Title title="" description="Left Icon" />
                    <CGE.Button leftIcon="left" label="Button" href="https://www.liferay.com/" />
                </div>
                <div className="col-md-2">
                    <CGE.Title title="" description="Right Icon Blank" />
                    <CGE.Button rightIcon="right" label="Button" href="https://www.liferay.com/" blank={true} />
                </div>
                <div className="col-md-2">
                    <CGE.Title title="" description="Left Icon Disabled" />
                    <CGE.Button leftIcon="left" disabled={true} label="Button" href="https://www.liferay.com/" />
                </div>
                <div className="col-md-2">
                    <CGE.Title title="" description="Right Icon Disabled" />
                    <CGE.Button rightIcon="right" disabled={true} label="Button" href="https://www.liferay.com/" />
                </div>
            </div>
            <div className="row">
                <div className="col-md-2">
                    <CGE.Title title="" description="Ghost" />
                    <CGE.Button type="ghost" label="Button" onClick={() => { alert("Ghost") }} />
                </div>
                <div className="col-md-2">
                    <CGE.Title title="" description="Ghost Disabled" />
                    <CGE.Button type="ghost" disabled={true} label="Button" />
                </div>
                <div className="col-md-2">
                    <CGE.Title title="" description="Ghost Left Icon" />
                    <CGE.Button type="ghost" leftIcon="left" label="Button" href="https://www.liferay.com/" />
                </div>
                <div className="col-md-2">
                    <CGE.Title title="" description="Ghost Right Icon Blank" />
                    <CGE.Button type="ghost" rightIcon="right" label="Button" href="https://www.liferay.com/" blank={true} />
                </div>
                <div className="col-md-2">
                    <CGE.Title title="" description="Ghost Left Icon Disabled" />
                    <CGE.Button type="ghost" leftIcon="left" disabled={true} label="Button" href="https://www.liferay.com/" />
                </div>
                <div className="col-md-2">
                    <CGE.Title title="" description="Ghost Right Icon Disabled" />
                    <CGE.Button type="ghost" rightIcon="right" disabled={true} label="Button" href="https://www.liferay.com/" />
                </div>
            </div>
            <div className="row">
                <div className="col-md-2">
                    <CGE.Title title="" description="Only Icon" />
                    <CGE.Button icon="only-icon" onClick={() => { alert("Ghost") }} />
                </div>
                <div className="col-md-2">
                    <CGE.Title title="" description="Only Icon Disabled" />
                    <CGE.Button icon="only-icon" disabled={true} />
                </div>
                <div className="col-md-2">
                    <CGE.Title title="" description="Only Icon Ghost Blank" />
                    <CGE.Button type="ghost" icon="only-icon" href="https://www.liferay.com/" blank={true} />
                </div>
                <div className="col-md-2">
                    <CGE.Title title="" description="Only Icon Ghost Disabled" />
                    <CGE.Button type="ghost" icon="only-icon" disabled={true} />
                </div>
                <div className="col-md-2">
                    <CGE.Title title="" description="Only Icon Cicle Blank" />
                    <CGE.Button type="only-icon-cicle" icon="icon-only-icon-cicle" href="https://www.liferay.com/" blank={true} />
                </div>
                <div className="col-md-2">
                    <CGE.Title title="" description="Only Icon Cicle Disabled" />
                    <CGE.Button type="only-icon-cicle" icon="icon-only-icon-cicle" disabled={true} />
                </div>
            </div>
            <div className="bg-white">
                {/* Versao default */}
                <CGE.FormsField
                    horizontal={true}
                    labelName="Nro. de Cliente: "
                    handleChange={handleChangeNumberCliente1}
                    idFormElement="numberClientId1"
                    typeFormElement="text"
                    mandatoryElement={true}
                    typeElement={'input'}
                    hasError={false}
                    msgError={"Ocorreu um erro"}
                    placeholder={'placeholder...'}
                    value={inputValue1}
                />
                <CGE.Spacing type={'sm'} />
                {/* Versao com Erro */}
                <CGE.FormsField
                    labelName="Nro. de Cliente: "
                    handleChange={handleChangeNumberCliente2}
                    idFormElement="numberClientId2"
                    typeFormElement="text"
                    mandatoryElement={true}
                    typeElement={'input'}
                    hasError={true}
                    msgError={"Ocorreu um erro"}
                    placeholder={'placeholder...'}
                    value={inputValue2}
                />
                <CGE.Spacing type={'lg'} />
                {/* Versao de Sucesso */}
                <CGE.FormsField
                    horizontal={true}
                    labelName="Nro. de Cliente: "
                    successMode={true}
                    handleChange={handleChangeNumberCliente3}
                    idFormElement="numberClientId3"
                    typeFormElement="text"
                    mandatoryElement={true}
                    typeElement={'input'}
                    hasError={false}
                    msgError={"Ocorreu um erro"}
                    placeholder={'placeholder...'}
                    value={inputValue3}
                />
                <CGE.Spacing type={'md'} />
                {/* Versao desable */}
                <CGE.FormsField
                    horizontal={true}
                    labelName="Nro. de Cliente: "
                    successMode={true}
                    handleChange={handleChangeNumberCliente4}
                    idFormElement="numberClientId4"
                    typeFormElement="text"
                    mandatoryElement={true}
                    typeElement={'input'}
                    hasError={false}
                    msgError={"Ocorreu um erro"}
                    placeholder={'placeholder...'}
                    value={inputValue4}
                    disabled={true}
                />
                {/* Versao select */}
                <CGE.FormsField
                    horizontal={true}
                    labelName="Nro. de Cliente: "
                    successMode={true}
                    handleChange={handleChangeNumberCliente5}
                    idFormElement="numberClientId5"
                    typeFormElement="text"
                    mandatoryElement={true}
                    typeElement={'select'}
                    listOptions={listOptions}
                    hasError={false}
                    msgError={"Ocorreu um erro"}
                    placeholder={'placeholder...'}
                    value={inputValue5}
                />
                {/* Versao disabled */}
                <CGE.FormsField
                    horizontal={true}
                    labelName="Nro. de Cliente: "
                    successMode={true}
                    handleChange={handleChangeNumberCliente6}
                    idFormElement="numberClientId5"
                    typeFormElement="text"
                    mandatoryElement={true}
                    typeElement={'select'}
                    listOptions={listOptions}
                    hasError={false}
                    msgError={"*Ocorreu um erro"}
                    placeholder={'placeholder...'}
                    value={inputValue6}
                    disabled={true}
                />
            </div>

            <div className="row">
                <div className="col-md-12">
                    <CGE.Title title="Card" description="" />
                </div>
            </div>
            <div className="row">
                <div className="col-md-4">
                    <CGE.Card label="Deuda Facturada" dataInfoShow="$554.500" disabled={true} id="id1" onClick={() => alert("Click")} />
                </div>
                <div className="col-md-4">
                    <CGE.Card label="Deuda Facturada Vencida" description="Boleta Anterior" onClick={() => alert("Click")} dataInfoShow="$541.700" id="id2" />
                </div>
                <div className="col-md-4">
                    <CGE.Card label="Deuda Facturada Vencida" disabled={true} description="Tercera Boleta" dataInfoShow="$527.500" id="id3" />
                </div>
            </div>
        </>
    );
};

export default CgeStyleGuide;
